export function postcodesToCsv(features) {
  const rows = features.map((f) => {
    const p = f.properties || {};
    return {
      country: p.country || '',
      postcode: p.plz || '',
      name: p.note || p.name || p.ort || p.city || ''
    };
  }).filter((r) => r.postcode);

  rows.sort((a, b) => (a.country + a.postcode).localeCompare(b.country + b.postcode));
  const dedup = new Map();
  for (const r of rows) dedup.set(`${r.country}|${r.postcode}`, r);

  const header = 'country,postcode,name\n';
  const body = [...dedup.values()]
    .map((r) => `${r.country},${r.postcode},${escapeCsv(r.name)}`)
    .join('\n');
  return header + body + '\n';
}

function escapeCsv(s) {
  if (s == null) return '';
  const str = String(s);
  if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
  return str;
}

export function downloadCsv(filename, csv) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
